define(function (require) {
	//#region Profile String

	//update this as we add profile/roles. These will need to be in order of importance, most to least.
	let getProfilePrefixes = () => {
		let prefixes = [];
		if (App.user) {
			if (App.user.isLoggedInToOrganizationProfile) {
				prefixes.push('_ORG_');
			}
			if (App.user.hasOrganizationProfiles) {
				prefixes.push('_AU_');
			}
		}
		prefixes.push('');//default to get the default string
		return prefixes;
	}

	//this function builds the localization string name based on the prefixes and the localization name
	let buildLocalizationName = (prefix, localizationName) => {
		let split = localizationName.split('.');
		let newLocalizationName = '';
		split.forEach((el, index) => {
			if (index == 0) {
				newLocalizationName += el;
			} else if (index == split.length - 1) {
				newLocalizationName += '.' + prefix + el;
			} else {
				newLocalizationName += '.' + el;
			}
		});
		return newLocalizationName;
	}

	//this builds an array of localization string names, then passes them in to the i18n.t function
	// to get the first one that exists.
	let getLocalizedString = (prefixes, localizationName, hash) => {
		//if we escape the value, any special chars in the name get displayed as &lt; etc. I am not sure why this is different than the {{t XX.YY.ZZ}} behavior in handlebars.
		hash.interpolation = { escapeValue: false }
		//localizationNames is an array of localization strings in order of priority.
		let localizationNames = [];
		prefixes.forEach(prefix => {
			localizationNames.push(buildLocalizationName(prefix, localizationName));
		});

		//the i18n.t function will return the first string that it finds in the array, so we can use this to prioritize them
		return i18n.t(localizationNames, hash);
	}

	//the hash is an object with the parameters for a given localization string. it may or may not be present.
	//the hash seems to come in various forms, so we need to check several places for it.
	let getLocalizationHash = (args) => {
		let hash = {};
		if (args && args.length == 1) {
			hash = args[0];
			if (hash.hash) {
				hash = hash.hash;
			}
		} else if (args && args.length >= 1) {
			args.forEach(arg => {
				if (arg.hash) {
					hash = arg.hash;
				}
			});
		}
		if(hash['orgName'] == null && App.user.isLoggedInToOrganizationProfile){
			hash['orgName'] = App.user.organizationName;
		}
		return hash;
	}
	//#end region
	//#region public functions
	return {
		//this function will make use of the user information on the App object to make a determination about which string to show a user.
		profileString(localizationName, passedArgs) {
			let hash = getLocalizationHash(passedArgs);
			//if we're not logged in as an org, just return the regular localized string. this behavior might need to be adjusted in the future.
			if (!App.user || !App.user.isLoggedInToOrganizationProfile) {
				return i18n.t(localizationName, hash);
			}

			return getLocalizedString(getProfilePrefixes(), localizationName, hash);
		}
	}
	//#end region
});
